import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({

    titleContainer: {
        flexDirection: 'row',
        marginTop: 12,
        fontSize: 11,
        textAlign: 'justify',
        textJustify: 'auto',
        color: "#474747"
    },
    horizontalLine:{
        borderBottomColor: 'black',
        borderBottomWidth: 1,
        marginTop: "40px"
    }
});


const FinalMessage = () => (
    <Fragment>
        <View 
            style={styles.horizontalLine}
        />
        <View style={styles.titleContainer}>
            <Text >AVISO: la información facilitada por este sistema automático de respuestas se tiene que entender válida en la
                medida en que no surjan nuevos hechos que la desvirtúen u otros elementos que no se hayan hecho constar en
                las consultas y, en todo caso, la respuesta tiene carácter meramente informativo. No tiene tampoco carácter de
                solicitud, ni de resolución y no comporta ningún efecto de tramitación, ni de registro.</Text>
        </View>
    </Fragment>
);

export default FinalMessage